import React from 'react';
import { CardRow } from './CardRow.js';

export function CardSection({ gameState, myPlayerState, isMyTurn, onBuyCard, onReserveCard, onBlindReserve }) {
  return (
    <div className="cards-section">
      <h3>开发卡</h3>
      {[3, 2, 1].map(level => (
        <CardRow
          key={level}
          gameState={gameState}
          myPlayerState={myPlayerState}
          isMyTurn={isMyTurn}
          cardLevel={level}
          onBuyCard={onBuyCard}
          onReserveCard={onReserveCard}
          onBlindReserve={onBlindReserve}
        />
      ))}
    </div>
  );
}
